/* Radiant header: menu, logo, cart (all non-home pages) */
(function () {
  'use strict';
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion:reduce)').matches;
  var bb = document.getElementById('burger'), mn = document.getElementById('mnav');
  if (bb && mn) {
    var set = function (o) {
      mn.hidden = !o;
      bb.setAttribute('aria-expanded', o ? 'true' : 'false');
      bb.setAttribute('aria-label', o ? 'close menu' : 'open menu');
    };
    bb.addEventListener('click', function () { set(mn.hidden); });
    mn.addEventListener('click', function (e) { if (e.target.tagName === 'A') set(false); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') set(false); });
    window.addEventListener('resize', function () { if (innerWidth > 1100) set(false); });
  }
  var l = document.querySelector('.rc-chrome header .logo');
  var sv = l && l.querySelector('.inkl');
  if (sv) {
    var busy = false, t;
    var go = function () {
      if (busy || reduce) return;
      busy = true;
      sv.classList.remove('go'); void sv.getBoundingClientRect(); sv.classList.add('go');
      clearTimeout(t);
      t = setTimeout(function () { sv.classList.remove('go'); busy = false; }, 3500);
    };
    l.addEventListener('mouseenter', go);
    l.addEventListener('focus', go);
    l.addEventListener('touchstart', go, { passive: true });
    l.addEventListener('click', go);
  }
  /* cart: open Dawn's drawer from our link; keep the count fresh */
  var cc = document.getElementById('cc');
  var link = document.getElementById('rc-cart');
  var dummy = document.getElementById('cart-icon-bubble');
  if (link && dummy && document.querySelector('cart-drawer')) {
    link.addEventListener('click', function (e) { e.preventDefault(); dummy.click(); });
  }
  function count() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { if (cc) cc.textContent = c.item_count; })
      .catch(function () {});
  }
  if (dummy && 'MutationObserver' in window) {
    new MutationObserver(count).observe(dummy, { childList: true, subtree: true, characterData: true });
  }
  document.addEventListener('cart:updated', count);
})();
